(function ($) {
  Drupal.behaviors.fwp3414ContentImageProductV1 = {
    formatter: $('.fwp-3-4-1-4-content-image-product-v1'),

    attach: function (context, settings) {
      var href = $('.top .button.cta', this.formatter).attr('href');

      // Link the main image to the same URL as the cta button
      if (typeof href !== 'undefined') {
        if (href.length > 0) {
          this.formatter.find('.bottom .left').children('img').wrap('<a></a>').parent('a').attr('href', href);
        }
      }
    }
  };
})(jQuery);
